module.exports = __webpack_public_path__ + "static/august-blk-8332b7d998d5b32c01aab72c8f7c3c31.jpeg";